import axios from 'axios';
import store from './store';
import { getAboutMe, getExperince, getEducation, getSkills, getReferences } from './redux/actions';
const baseUrl = '/data';

const getData = () => {
  axios.get(`${baseUrl}/about-me.json`).then(res => {
    const aboutMe = res.data.data.about;
    store.dispatch(getAboutMe(aboutMe));
  });

  axios.get(`${baseUrl}/experience.json`).then(res => {
    const experience = res.data.data.experience;
    store.dispatch(getExperince(experience));
  });

  axios.get(`${baseUrl}/education.json`).then(res => {
    const education = res.data.data.education;
    store.dispatch(getEducation(education));
  });

  axios.get(`${baseUrl}/skills.json`).then(res => {
    const skills = res.data.data.skills;
    store.dispatch(getSkills(skills));
  });
};

export default getData;
